import { render, staticRenderFns } from "./CompanyLeaveAssignmentPageTable.vue?vue&type=template&id=4aad1005&scoped=true&"
import script from "./CompanyLeaveAssignmentPageTable.vue?vue&type=script&lang=js&"
export * from "./CompanyLeaveAssignmentPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad1005",
  null
  
)

export default component.exports